// extracted by mini-css-extract-plugin
export default {"content_wrapper":"MyMoviesPage_content_wrapper__OEFSp","section_title":"MyMoviesPage_section_title__WQxXU"};